import React from 'react';
import CustomModal from '../../../components/Modal/CustomModal';
import BuildingForm from '../SubComponents/BuildingForm';
import {CreateBuildingModalApp} from '../Functionality/CreateBuildingModalApp';

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 * @param {string} title - Modal title text
 * @param {boolean} show - Controls modal visibility
 * @param {Function} onHide - Closes the modal
 * @param {boolean} modified - Indicates if the list data has changed
 * @param {Function} setModified - Flags the list to be reloaded after a successful creation
 * @returns {JSX.Element} - React component for adding buildings
 * @constructor
 */

const CreateBuildingModal = ({ title, show, onHide, modified, setModified }) => {
    const {t, item, handleChange, clearButton, handleCreateBuilding, handleCleanClick, emptyFields,
        getListStatus, employeeWorkStations, handleClose, showOverlay, overlayHiding, handleMouseEnter, handleMouseLeave, handleMapChange
    } = CreateBuildingModalApp({
        show,
        onHide,
        modified,
        setModified
    });

    return (
        <>
            <CustomModal show={show}
                         size='lg'
                         onConfirm={handleCreateBuilding}
                         title={title}
                         rightTitleButton={clearButton()}
                         onHide={handleClose}
                         classNameBody="pt-2"
            >
                <BuildingForm
                    idPrefix={'cbm'}
                    item={item}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    getListStatus={getListStatus}
                    employeeWorkStations={employeeWorkStations}
                    t={t}
                    handleCleanClick={handleCleanClick}
                    showOverlay={showOverlay}
                    overlayHiding={overlayHiding}
                    handleMouseEnter={handleMouseEnter}
                    handleMouseLeave={handleMouseLeave}
                    handleMapChange={handleMapChange}
                />
            </CustomModal>
        </>
    );
};

export default CreateBuildingModal;
